/*
 *
 * File JS Principale
 *
 */

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import 'lightgallery/css/lightgallery-bundle.min.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'scss/app.scss';
//--------------------------------------------------------------------//

// Carichiamo i font in maniera asincrona
//--------------------------------------------------------------------//

var Webfont = require('webfontloader');

Webfont.load({
    google: {
        families: ['Baskervville', 'Poppins:400,500,600,700&display=swap'],
    },
});

//--------------------------------------------------------------------//

// Libreria Lazysizes
//--------------------------------------------------------------------//
import 'lazysizes';

//--------------------------------------------------------------------//

//--------------------------------------------------------------------//

// Import Utilies
//--------------------------------------------------------------------//
import { initSvgImage } from './utilities/img-svg';
import smoothScroll from './utilities/smooth-scroll';
//--------------------------------------------------------------------//

// Init Utilies
//--------------------------------------------------------------------//

initSvgImage();
smoothScroll();

//--------------------------------------------------------------------//

// Import Componenti
//--------------------------------------------------------------------//

import initHeader from 'components/header/header';
import marquee from 'components/marquee/marquee';
import button from 'components/buttons/buttons';
import animateIn from 'animations/animate-in/animate-in';
import footer from 'components/footer/footer';

//--------------------------------------------------------------------//
if (!document.querySelector('body.wp-admin')) {
    initHeader();
    marquee();
}
animateIn();
